window.lpTag = window.lpTag || {};
lpTag.taglets = lpTag.taglets || {};
//mimeType - string - the mime type we expect - application/json by default
//type - string - GET/POST/PUT/DELETE - GET by default
//data - object - the data we want to send on the request
//encoding - string -the encoding for the request - default UTF-8
//XMLHTTPOverride - boolean - for DELETE/PUT requests, this defines if we should add the X-HTTP-Method-Override header, default true
//cache - boolean - default false, if set to true request will appear identical and the browser will cache them sparing requests
//url - string - the url we will be using
//asynch - boolean - if the call should be asynch or not - default asynch
//headers - object - additional headers we want to add to the request
/**
 *  The object to send XHR requests to the same domain
 */
lpTag.taglets.xhr = lpTag.taglets.xhr || (function lpXHR(window) {

    var contentTypes = {
            JSON: "application/json",
            JAVASCRIPT: "text/javascript",
            HTML: "text/html",
            XMLAPP: "application/xml",
            XMLTEXT: "text/xml",
            FORM: "application/x-www-form-urlencoded;"
        },//Mime types that are acceptable should be overrriden when known in advance and set as a header with encoding when sending
        requestTypes = {
            GET: "GET",
            POST: "POST",
            PUT: "PUT",
            PATCH: "PATCH",
            DELETE: "DELETE"
        },
        xhrEvents = {
            PROGRESS: "progress",
            LOAD: "load",
            ERROR: "error",
            ABORT: "abort",
            READYSTATE: "readystatechange"
        },
        logTypes = { ERROR: "ERROR", DEBUG: "DEBUG", INFO: "INFO" },
    //resType = { EMPTY_STRING: "", ARRAYBUFFER: "arraybuffer", BLOB: "blob", DOCUMENT: "document", JSON: "json" },
        defaults = {
            encoding: "UTF-8",
            method: requestTypes.GET,
            asynch: true,
            timeout: 30000,
            mimeType: contentTypes.JSON,
            cache: false,
            acceptHeader: "*/*",
            XMLHTTPOverride: true,
            retries: 2,
            metricsCount: 100,
            metricsTimeout: 60000
        },
        xhrState = {
            UNSENT: 0,
            OPENED: 1,
            HEADERS_RECIEVED: 2,
            LOADING: 3,
            COMPLETE: 4
        },
        transportType = "xhr",
        version = "1.1.8",
        subDomain = _getSubDomain(document.location.href),
        XHTTPOverRideHeader = "X-HTTP-Method-Override",
        badRequestObj = { responseCode: 404, HTTPStatus: "bad request", body: { error: "Request timed out"}, headers: "" },
        invalidRequest = { responseCode: 600, HTTPStatus: "unable to service request", body: { error: "Transport - " + transportType + " - unable to run request" }, headers: "" },
        isIE8Mode = !window.addEventListener,
        maxURLLength = 2083,
        callCount = 0,
        errorCount = 0,
        metricsTOId,
        buffer = [],
        pendingRequests = [],
        errorTimeoutId,
        requestStats = [],
        initialised = true,
        taglets = lpTag.taglets,
        lpAjax;


    /**
     * Where it all starts
     */
    function init() {
        if (taglets.lpAjax && taglets.lpAjax.addTransport) {
            lpAjax = taglets.lpAjax;
            try {
                lpAjax.addTransport(transportType, publicAPI);
            } catch (exc) {}
        }
        _setMetricsTimeout();
    }

    /**
     * Set new defaults for request
     * that this layer makes
     */
    function configure(configuration) {
        if (configuration && configuration.defaults) {
            for (var key in configuration.defaults) {
                if (configuration.defaults.hasOwnProperty(key) && defaults.hasOwnProperty(key)) {
                    defaults[key] = configuration.defaults[key];
                }
            }
        }
        init();
        initialised = true;
    }

    /**
     * Validates this transport can handle the request
     * Conditions are same domain and get request smaller than
     * URL length maximum (also sets request defaults for the check)
     * @param reqObj
     * @return {Boolean}
     */
    function isValidRequest(reqObj) {
        reqObj = _setRequestDefaults(reqObj);
        var validRequest = false;
        if (reqObj && reqObj.url && typeof reqObj.url === 'string') {
            if (subDomain == _getSubDomain(reqObj.url)) {
                if (!reqObj.method || reqObj.method.toLowerCase() === requestTypes.GET.toLowerCase()) {
                    var mUrlLength = maxURLLength, query = "";
                    if (reqObj.url.indexOf("http") !== 0) {
                        reqObj.url = _fixURL(reqObj.url);
                    }
                    try {
                        if (reqObj.query) {
                            query = _convertDataToQueryParams(reqObj.query);
                        }
                        if (reqObj.data) {
                            query += _convertDataToQueryParams(reqObj.data);
                        }
                    } catch (e) {
                        _log("Error stringifying data", logTypes.ERROR);
                        validRequest = false;
                    }
                    if (!reqObj.cache) {
                        mUrlLength = mUrlLength - 10;
                    }
                    if ((reqObj.url.length + 1 + query.length) <= mUrlLength) {
                        validRequest = true;
                    }
                } else {
                    validRequest = true;
                }
            }
        }
        return (initialised && validRequest);
    }


    /**
     * Makes or buffers a call depending on
     * the state of the transport
     * @param reqObj
     */
    function issueCall(reqObj) {
        if (isValidRequest(reqObj)) {
            _addToBuffer(reqObj);
        } else if (reqObj && reqObj.error) {
            _runCallback(reqObj.error, invalidRequest, reqObj.context);
        }
    }

    /**
     * Returns the configuration for the transport
     * @returns {{name: string, version: string, callsMade: number, errorsFound: number, pending: (Array.length|*), defaults}}
     */
    function inspect() {
        return {
            name: transportType,
            version: version,
            callsMade: callCount,
            errorsFound: errorCount,
            pending: pendingRequests.length,
            defaults: JSON.parse(_stringify(defaults))
        };
    }

    /**
     * Sets the request defaults according to what was
     * specified for the layer
     * @param reqObj
     * @return {*}
     */
    function _setRequestDefaults(reqObj) {
        reqObj.method = reqObj.method || defaults.method;
        reqObj.encoding = reqObj.encoding || defaults.encoding;
        reqObj.mimeType = reqObj.mimeType || defaults.mimeType;
        reqObj.retries = !isNaN(reqObj.retries) ? reqObj.retries : defaults.retries;
        reqObj.timeout = !isNaN(reqObj.timeout) ? reqObj.timeout : defaults.timeout;
        reqObj.XMLHTTPOverride = typeof reqObj.XMLHTTPOverride == 'boolean' ? reqObj.XMLHTTPOverride : defaults.XMLHTTPOverride;
        reqObj.cache = typeof reqObj.cache === 'boolean' ? reqObj.cache : defaults.cache;
        reqObj.asynch = typeof reqObj.asynch === 'boolean' ? reqObj.asynch : defaults.asynch;
        //Default override for PUT/Delete unless explicitly requested to ignore
        if ((reqObj.method.toLowerCase() === requestTypes.PUT.toLocaleLowerCase() ||
            reqObj.method.toLowerCase() === requestTypes.DELETE.toLocaleLowerCase()) &&
            reqObj.XMLHTTPOverride) {
            reqObj.headers[XHTTPOverRideHeader] = reqObj.method;
            reqObj.method = requestTypes.POST;
        }
        return reqObj;
    }

    /**
     * Add a random number to the request to
     * make sure we don't get the cached browser
     * response back
     * @param reqObj
     */
    function _addCacheBuster(reqObj) {
        var indexOfRnd = reqObj.url.indexOf("__d=");
        if (indexOfRnd > -1) {
            reqObj.url = reqObj.url.substr(0, indexOfRnd - 1);
        }
        if (!reqObj.cache && (reqObj.method.toLowerCase() !== requestTypes.GET.toLowerCase() || reqObj.url.length <= (maxURLLength - 10))) {
            reqObj.url += reqObj.url.indexOf("?") > 0 ? "&__d=" : "?__d=";
            reqObj.url += Math.floor(Math.random() * 100000);
        }
    }

    /**
     * If a partial URL was passed in
     * we make it a full URL, this is needed for calculating the actual length
     * @param url
     * @return {String} - the url with the base location
     */
    function _fixURL(url) {
        var locationEnd = document.location.href.lastIndexOf("/") || document.location.href.lastIndexOf("?");
        var urlBase = document.location.href.substr(0, locationEnd);
        url = urlBase + "/" + url;
        return url;
    }

    /**
     * Function to extract the sub domain from any URL
     * @param url
     * @return {String}
     */
    function _getSubDomain(url) {
        var domainRegEx = new RegExp(/(http{1}s{0,1}?:\/\/)([^\/\?]+)(\/?)/ig);
        var matches, domain = null;
        if (url.indexOf("http") === 0) {
            matches = domainRegEx.exec(url);
        } else {
            matches = domainRegEx.exec(window.location.href);
        }
        if (matches && matches.length >= 3 && matches[2] !== "") {
            domain = matches[1].toLowerCase() + matches[2].toLowerCase(); // 0 - full match 1- HTTPS 2- domain
        }
        return domain;
    }

    /**
     * Sets the request headers on the XHR request
     * after fixing them
     * @param xhr
     * @param headers
     * @param reqObj
     * @return {*}
     */
    function _addHeaders(xhr, headers, reqObj) {
        headers = headers || {};
        //It is always best to _send these two headers so we force them for all requests
        headers["Content-Type"] = _fixContentTypeHeader(headers["Content-Type"] || defaults.mimeType, reqObj.encoding);
        headers.Accept = headers.Accept || defaults.acceptHeader;
        headers["X-Requested-With"] = "XMLHttpRequest";
        if (headers) {
            for (var key in headers) {
                if (headers.hasOwnProperty(key)) {
                    try {
                        xhr.setRequestHeader(key, headers[key]);
                    } catch (err) {
                    }
                }
            }
        }
        return xhr;
    }

    /**
     * Sets the content type header if none
     * was set and encoding
     * @param value
     * @param charset
     * @return {*}
     */
    function _fixContentTypeHeader(value, charset) {
        var res = value;
        if (!res || res === "" || res.indexOf("charset") < 0) {
            res = (res || defaults.MIMETYPE) + "; charset=" + (charset || defaults.encoding);
        }
        return res;
    }

    /**
     * Sends the requests in the buffer
     * @param reqObj
     * @return {Boolean}
     */
    function _send(reqObj) {
        var xhr = isIE8Mode ? _getBoundXHRIE8(reqObj) : _getBoundXHR(reqObj);
        if (xhr.overrideMimeType) {
            xhr.overrideMimeType(reqObj.mimeType);
        }
        try {
            if (reqObj.query) {
                reqObj.url = _setUrlQuery(reqObj.url, reqObj.query);
                reqObj.query = null;
            }
            if (reqObj.method === requestTypes.GET && reqObj.data) {
                reqObj.url = _setUrlQuery(reqObj.url, reqObj.data);
                reqObj.data = null;//Make sure we don't make the same changes in case of retry
            } else {//PUT/POST/DELETE requests can have a body
                if (typeof reqObj.data !== 'undefined') {
                    reqObj.data = _stringifyData(reqObj.data);
                }
            }
        } catch (exc) {//Error stringifying Data
            _handleError(reqObj, xhr, false, { responseCode: 601, HTTPStatus: "Unable to service request", headers: "", body: { error: "unable to stringify data for requests" } });
            return false;
        }
        //Prevent caching request by adding random to URL
        _addCacheBuster(reqObj);
        reqObj.xhr = xhr;
        xhr.open(reqObj.method, reqObj.url, reqObj.asynch);//Allow setting requests to synchronus
        xhr = _addHeaders(xhr, reqObj.headers, reqObj);//This has to happen after we open the connection
        _addToPendingRequests(reqObj);
        xhr.send(reqObj.data || null);
        if (!errorTimeoutId) {
            setTimeout(_checkErrors, 1000);
        }
        return true;
    }

    /**
     * Build URL query as GET
     * @param url
     * @param data
     * @returns {*}
     */
    function _setUrlQuery(url, data) {
        var dataString;
        dataString = _convertDataToQueryParams(data);
        if (dataString) {
            url += url.indexOf("?") < 0 ? "?" : "&";
            url += dataString;
        }
        return url;
    }

    /**
     * Adds to the list of requests we sent
     * and adds flags for when we started this request to make sure
     * we can time it out properly
     * @param reqObj
     */
    function _addToPendingRequests(reqObj) {
        reqObj.launchTime = new Date();
        pendingRequests.push(reqObj);
        _incrementCalls();
    }

    /**
     * Adds a request to the queue waiting for calls
     * And checks if it can be sent
     * @param reqObj
     */
    function _addToBuffer(reqObj) {
        buffer.push(reqObj);
        _checkBuffer();
    }

    /**
     * Checks for timeout errors
     * on pending requests
     */
    function _checkErrors() {
        if (errorTimeoutId) {
            clearTimeout(errorTimeoutId);
            errorTimeoutId = null;
        }

        var now = new Date();
        var errors = [];
        for (var i = 0; i < pendingRequests.length; i++) {
            var req = pendingRequests[i];
            var timeElapsed = now.valueOf() - req.launchTime.valueOf();
            if (timeElapsed > req.timeout) {
                _handleError(req, req.xhr, true);
                errors.push(req);
            }
        }
        for (var j = 0; j < errors.length; j++) {
            _removeFromPending(errors[j]);
            errors[j] = null;
        }

        if (buffer.length > 0 || pendingRequests.length > 0) {
            errorTimeoutId = setTimeout(_checkErrors, 1000);
        }
    }

    /**
     * Generic function for all error callbacks
     * @param reqObj - the original request
     * @param xhr - the XHR of this request
     * @param abortCall - whether this is a timeout
     * @param res - response data for this request if it exists
     */
    function _handleError(reqObj, xhr, abortCall, res) {
        _incrementErrors();
        if (reqObj.launchTime) {
            _addToStats(reqObj.launchTime.getTime(), reqObj.url, reqObj.method, res && res.responseCode || 408);
        }
        if (!abortCall) {//In case we're checking for errors, so we don't change the pending request array when iterating through it
            _removeFromPending(reqObj);
        }
        _cleanUpPropertiesFromReq(reqObj);
        if (abortCall && xhr) {
            try {
                xhr.abort();
            } catch (exc) {
                _log("Error when trying to abort request " + reqObj.url, logTypes.ERROR);
            }
        }

        if (xhr) {
            _clearXHR(xhr);
        }

        if (reqObj.retries > 0 && !res) {
            reqObj.retries = reqObj.retries - 1;
            _addToBuffer(reqObj);
        } else {
            _runCallback(reqObj.error, res || badRequestObj, reqObj.context);
        }
    }

    /**
     * Takes the data parameter and converts it to a query string
     * @param data
     * @return {String}
     */
    function _convertDataToQueryParams(data) {
        var queryString = "";
        if (typeof data === 'string') {
            queryString += data;
        } else {
            var first = true;
            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    var value;
                    if (typeof data[key] == 'object') {
                        value = _stringify(data[key]);
                    } else if (typeof data[key] !== 'function') {
                        value = data[key];
                    }
                    if (typeof value !== 'undefined') {
                        if (!first) {
                            queryString += "&";
                        }
                        queryString += encodeURIComponent(key) + "=" + encodeURIComponent(value);
                        first = false;
                    }
                }
            }
        }
        return queryString;
    }

    /**
     * Deletes any properties we set on the original request
     * Cleanup
     * @param reqObj
     */
    function _cleanUpPropertiesFromReq(reqObj) {
        var properties = ["xhr"];
        for (var i = 0; i < properties.length; i++) {
            reqObj[properties[i]] = null;
            delete reqObj[properties[i]];
        }
    }

    /**
     * Stringifies the data we're going
     * to _send on the request
     * @param data
     * @return {*}
     */
    function _stringifyData(data) {
        if (typeof data === 'object') {
            return _stringify(data);
        } else if (typeof data === 'string') {
            return data;
        } else {
            return '';
        }
    }

    /**
     * This function was added because of incompatibility between the JSON.stringify and Prototype.js library
     * When a costumer uses Prototype.js library, It overrides the Array.prototype.toJSON function the the native JSON
     * uses. This causes arrays to be double quoted and Shark to fail on those SDEs.
     * The function accepts a value and and uses the native JSON.stringify
     * Can throw an exception (same as JSON.stringify).
     */
    function _stringify(value) {
        var stringified;
        if (typeof Array.prototype.toJSON === 'function') {
            var toJSONPrototype = Array.prototype.toJSON;
            delete Array.prototype.toJSON;
            try {
                stringified = JSON.stringify(value);
            } catch (e) {
                Array.prototype.toJSON = toJSONPrototype;
                throw e;
            }
            Array.prototype.toJSON = toJSONPrototype;
        } else {
            stringified = JSON.stringify(value);
        }
        return stringified;
    }

    /**
     * Checks if we have pending requests in
     * our buffer and sends them
     * @return {Boolean}
     */
    function _checkBuffer() {
        while (pendingRequests.length < 6 && buffer.length > 0) {
            _send(buffer.shift());
        }
    }

    /**
     * Runs callback methods in a protected way
     * @param callback
     * @param data
     * @param context
     */
    function _runCallback(callback, data, context) {
        if (callback && typeof callback == 'function') {
            try {
                callback.call(context, data);
            } catch (e) {
                _log(e.message, "error");
            }
        }
    }

    /**
     * Writes a _log
     * @param msg
     * @param type
     * @return {*}
     */
    function _log(msg, type) {
        if (window.lpTag && lpTag.log) {
            lpTag.log(msg, type, transportType);
        }
    }

    /**
     * Creates a bounded XHR object
     * according to modern browsers
     * @param reqObj
     * @return {window.XMLHttpRequest}
     */
    function _getBoundXHR(reqObj) {
        var xhr = new window.XMLHttpRequest();
        xhr.addEventListener(xhrEvents.LOAD, function () {
            if (reqObj && !reqObj.completed) {
                _requestCompleted(this, reqObj);
                reqObj.completed = true;
            } else {
                reqObj = null;
            }
        });
        xhr.addEventListener(xhrEvents.PROGRESS, function () {
            var res = _createResObj(this);
            if (res && reqObj && reqObj.progress) {
                _runCallback(reqObj.progress, res, reqObj.context);
            }
        });

        xhr.addEventListener(xhrEvents.ERROR, function () {
            if (reqObj && !reqObj.completed) {
                _requestError(this, reqObj);
                reqObj.completed = true;
            } else {
                reqObj = null;
            }
        });

        xhr.addEventListener(xhrEvents.READYSTATE, function () {
            if (this.readyState === xhrState.COMPLETE) {
                if (reqObj && !reqObj.completed) {
                    _requestCompleted(this, reqObj);
                    reqObj.completed = true;
                } else {
                    reqObj = null;
                }
            }
        });
        return xhr;
    }

    /**
     * Creates a bounded object according to
     * IE8 browser limitations
     * @param reqObj
     * @return {window.XMLHttpRequest}
     */
    function _getBoundXHRIE8(reqObj) {
        var xhr = new window.XMLHttpRequest();
        xhr[xhrEvents.READYSTATE] = function () {
            if (!reqObj.completed) {
                if (this.readyState === xhrState.COMPLETE) {
                    _requestCompleted(this, reqObj);
                    reqObj.completed = true;
                }
            }
        };
        xhr[xhrEvents.ERROR] = function () {
            _requestError(this, reqObj);
        };
        return xhr;
    }

    /**
     * Cleans up an XHR request
     * @param xhr
     */
    function _clearXHR(xhr) {
        xhr[xhrEvents.READYSTATE] = null;
        xhr[xhrEvents.ERROR] = null;
        if (!isIE8Mode) {
            xhr[xhrEvents.PROGRESS] = null;
            xhr[xhrEvents.LOAD] = null;
        }
        xhr = null;
    }

    /**
     * Creates a result object
     * that's published when a request completes.
     * Returns an object with the following properties:
     * responseCode - the HTTP response code
     * HTTPStatus - the status text we got from the request
     * body - the data resulting from the request
     * headers - the headers returned from the request
     * @param xhr
     * @return {*}
     */
    function _createResObj(xhr) {
        var res, headerData;
        if (xhr) {
            try {
                headerData = _parseHeaders(xhr);//Convert headers to JSON object with original header as well
                res = {
                    responseCode: _getXhrProperty(xhr, "status") || 404,//Protected for on Error some properties don't exist
                    HTTPStatus: _getXhrProperty(xhr, "statusText"),
                    body: _getXhrProperty(xhr, "responseText", "string") || _getXhrProperty(xhr, "responseXML"),//Protected since in IE if not a string will throw exception on access attempt
                    headers: headerData.headers,
                    originalHeader: headerData.originalHeader
                };
            } catch (err) {
                _log(err.message, logTypes.ERROR);
                return {};
            }
        } else {
            _log("No data from request", logTypes.INFO);
            return {};
        }
        if (isJSONResponse(res)) {
            try {
                res.body = JSON.parse(res.body);
            } catch (err) {
            }
        }
        //IE response code faults
        res.responseCode = res.responseCode == 1223 ? 204 : res.responseCode;
        //IE weird response faults http://msdn.microsoft.com/en-us/library/windows/desktop/aa385465%28v=vs.85%29.aspx
        if (res.responseCode >= 12000) {
            res.internalCode = res.responseCode;
            res.responseCode = 500;
        }
        res.statusCode = res.responseCode;
        return res;
    }

    /**
     * Returns whether response is of content type: JSON
     * @param res
     * @return boolean
     */
    function isJSONResponse(res) {
        return res && res.headers && res.headers["Content-Type"] && res.headers["Content-Type"].indexOf(contentTypes.JSON) > -1;
    }

    /**
     * A method for getting info from the XHR
     * object. Some of it is not accessible if it's the wrong
     * type, so we enforce a type on the method
     * @param xhr
     * @param propertyName
     * @param type
     * @return {*}
     */
    function _getXhrProperty(xhr, propertyName, type) {
        try {
            if (type) {//Strict for preventing attempts to access types that will trow an exception
                if (typeof xhr[propertyName] === type) {
                    return xhr[propertyName];
                } else {
                    return "";
                }
            } else {
                return xhr[propertyName];
            }
        } catch (err) {
            return "";
        }
    }

    /**
     * A method for parsing the XHR
     * response headers into a normalized object
     * with the original header as a string as well
     * @param xhr
     * @return {Object}
     */
    function _parseHeaders(xhr) {
        var headerString, res = {};
        try {
            headerString = xhr.getAllResponseHeaders();
        } catch (err) {
            headerString = "";
        }
        if (headerString) {
            var hArray = headerString.split("\n");
            for (var k = 0; k < hArray.length; k++) {
                try {
                    var values = hArray[k].split(":");
                    if (values[0]) {
                        var value = values.length > 2 ? values.slice(1).join(':') : values[1];
                        res[_trim(values[0])] = _trim(value);
                    }
                } catch (err) {
                }
            }
        }
        return {
            originalHeader: headerString,
            headers: res
        };
    }

    /**
     * A function for trimming white space
     * in the beginning and end of strings
     * @param val
     * @return {*}
     */
    function _trim(val) {
        if (val && typeof val === 'string') {
            val = val.replace(/^[\s\r]*/, '');
            val = val.replace(/[\s\r]*$/g, '');
        }
        return val;
    }

    /**
     * A general method that handles a successful
     * response from the server
     * @param xhr
     * @param reqObj
     */
    function _requestCompleted(xhr, reqObj) {
        _cleanUpPropertiesFromReq(reqObj);
        var res = _createResObj(xhr);
        if (reqObj.launchTime) {
            _addToStats(reqObj.launchTime.getTime(), reqObj.url, reqObj.method, res.responseCode);
        }
        if (res) {
            var cb;
            if (res.responseCode > 399) {
                _handleError(reqObj, xhr, false, res);
            } else {
                _removeFromPending(reqObj);
                cb = reqObj.success;
                _runCallback(cb, res, reqObj.context);
                _clearXHR(xhr);
            }
        }
        _checkBuffer();
    }

    /**
     * A general method that handles errors
     * thrown by the request
     * @param xhr
     * @param reqObj
     */
    function _requestError(xhr, reqObj) {
        _handleError(reqObj, xhr);
        _checkBuffer();
    }

    /**
     * Increment the internal error counter
     */
    function _incrementErrors() {
        errorCount = errorCount + 1;
    }

    /**
     * Increment the internal call counter and
     * pending requests counter
     */
    function _incrementCalls() {
        callCount = callCount + 1;
    }

    /**
     * Removes the request from our pending list
     * @param reqObj
     */
    function _removeFromPending(reqObj) {
        for (var i = 0; i < pendingRequests.length; i++) {
            if (pendingRequests[i] === reqObj) {
                pendingRequests.splice(i, 1);
                break;
            }
        }
    }

    /**
     * Adding the time spent on the request
     * @param startTime
     * @param url
     * @param method
     * @param statusCode
     * @private
     */
    function _addToStats(startTime, url, method, statusCode) {
        var requestDuration, now;
        if (startTime) {
            now = new Date().getTime();
            requestDuration = (now - startTime);
            requestStats.push({
                rd: requestDuration,
                ts: startTime,
                url: url,
                method: method,
                statusCode: statusCode
            });

            if (requestStats.length >= defaults.metricsCount) {
                _publishMetrics();
            }
        }
    }

    /**
     * Publishes stats to lpAjax to decide if we want to report this
     */
    function _publishMetrics() {
        var res;
        if (taglets && taglets.lpAjax.publishMetrics && requestStats.length > 0) {
            lpAjax = taglets.lpAjax;
            res = {
                tags: [
                    { transport: transportType }
                ],
                metrics: requestStats
            };
            lpAjax.publishMetrics(res);
            requestStats.length = 0;
        }
        _setMetricsTimeout();
    }

    /**
     * Clears any previous timeout to set this data and sets up
     * the next time this should happen
     */
    function _setMetricsTimeout() {
        if (metricsTOId) {
            clearTimeout(metricsTOId);
        }
        metricsTOId = setTimeout(_publishMetrics, defaults.metricsTimeout);
    }


    if (isIE8Mode) {//Support for IE8
        xhrEvents.READYSTATE = "on" + xhrEvents.READYSTATE;
        xhrEvents.ERROR = "on" + xhrEvents.ERROR;
    }

    //Exposed methods
    var publicAPI = {
        init: init,
        name: transportType,
        v: version,
        configure: configure,
        issueCall: issueCall,
        isValidRequest: isValidRequest,
        inspect: inspect
    };

    init();
    return publicAPI;
})(window);